<div [class.no-gap]="noGap" [class.small-gap]="smallGap" [class]="sizeClass" [class.use-parent-height]="useParentHeight" class="dialog-container">
	@if (topBarTemplate) {
		<div class="top-bar-container">
			<ng-container [ngTemplateOutlet]="topBarTemplate"></ng-container>
		</div>
	}
	<div
		[class.multi-row]="multiRow"
		[class.no-padding]="noPadding"
		[class.scrollable]="scrollable"
		[class.use-parent-height]="useParentHeight"
		class="content-container"
	>
		<ng-content></ng-content>
	</div>
	@if (bottomBarRightTemplate || bottomBarLeftTemplate) {
		<div class="bottom-bar-container" [class.border]="bottomBorder">
			<div class="container-left">
				@if (bottomBarLeftTemplate) {
					<ng-container [ngTemplateOutlet]="bottomBarLeftTemplate"></ng-container>
				}
			</div>

			<div class="container-right">
				@if (bottomBarRightTemplate) {
					<ng-container [ngTemplateOutlet]="bottomBarRightTemplate"></ng-container>
				}
			</div>
		</div>
	}
</div>
